'use strict';
import * as $i_$0040ui5$002fwebcomponents$002fdist$002fInput$002ejs from "@ui5/webcomponents/dist/Input.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024 from "./com.raquo.laminar.codecs.package$.js";
import * as $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dString$002dUnion$002dCodec$0024$0024anon$00241 from "./io.github.nguyenyou.ui5.webcomponents.laminar.shared.-String-Union-Codec$$anon$1.js";
import * as $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent from "./io.github.nguyenyou.ui5.webcomponents.laminar.shared.-Web-Component.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Input$() {
  this.dz = null;
  this.cu = null;
  this.dV = null;
  this.dW = false;
  this.HX = null;
  this.HY = false;
  this.HZ = null;
  this.I0 = false;
  this.I1 = null;
  this.I2 = false;
  $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$ct_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent__T__(this, "ui5-input");
}
export { $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Input$ as $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Input$ };
$p = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Input$.prototype = new $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent();
$p.constructor = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Input$;
/** @constructor */
function $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Input$() {
}
export { $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Input$ as $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Input$ };
$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Input$.prototype = $p;
$p.ju = (function() {
  if ((!this.HY)) {
    this.HX = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "placeholder", $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024.$m_Lcom_raquo_laminar_codecs_package$().ci));
    this.HY = true;
  }
  return this.HX;
});
$p.Cv = (function() {
  if ((!this.I0)) {
    this.HZ = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "show-clear-icon", $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024.$m_Lcom_raquo_laminar_codecs_package$().gN));
    this.I0 = true;
  }
  return this.HZ;
});
$p.gK = (function() {
  if ((!this.I2)) {
    this.I1 = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "type", new $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dString$002dUnion$002dCodec$0024$0024anon$00241.$c_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_StringUnionCodec$$anon$1()));
    this.I2 = true;
  }
  return this.I1;
});
$p.cQ = (function() {
  return $i_$0040ui5$002fwebcomponents$002fdist$002fInput$002ejs.default;
});
var $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_Input$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Input$, "io.github.nguyenyou.ui5.webcomponents.laminar.Input$", ({
  jC: 1,
  ac: 1
}));
export { $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_Input$ as $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_Input$ };
var $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Input$;
function $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_Input$() {
  if ((!$n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Input$)) {
    $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Input$ = new $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Input$();
  }
  return $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Input$;
}
export { $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_Input$ as $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_Input$ };
